var $ = require('jquery');
var l10n = require('diy/util/l10n');

module.exports = {
    showTabletLandscapeNotification: function () {
        var
        /* @todo add featureIds in one place */
            TABLET_LANDSCAPE_MODE_NOTIFICATION = 1608,
            messages = l10n.getMessages('tabletNotifications.landscapeMode'),
            widgetEl = $('<div />'),
            contentEl = $(
                '<div class="tablet-landscape-info-overlay"></div>' +
                '<div class="tablet-landscape-info-content cp-style">' +
                    '<div>' + messages.text + '</div>' +
                    '<button class="blue-primary">' +
                    '<span>' + messages.button.label + '</span>' +
                    '</button>' +
                '</div>'
            );

        contentEl.find('button').button({});
        contentEl.on('click', function () {
            jQuery.ajax({
                url: '/app/help/service/disable-feature/?id=' + TABLET_LANDSCAPE_MODE_NOTIFICATION
            });

            $(window).unbind('orientationchange.tabletLandscapeNotification');
            widgetEl.diy_layer('destroy');
        });

        widgetEl.diy_layer({
            contentEl: contentEl,
            cls: 'tablet-landscape-info',
            zIndex: diy.editor.getNewTopZIndex(undefined, 'blockingModals')
        }).diy_layer('show');

        $(window).on('orientationchange.tabletLandscapeNotification', function() {
            //close the keyboard
            contentEl.find('button').focus();
        });
    }
};



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/tablet/landscapeModeInfo.js
 ** module id = 929
 ** module chunks = 0
 **/